<div class="auth-container">
  <div class="content">
    <div class="form-container">
      <div class="form-header">
        <img src="/assets/images/logo.png" class="form-logo" alt="logo" />
        <div class="title-wrapper">
          <h1 class="form-title">Sign into your account</h1>
          <p class="form-desc">Welcome back! Please enter your details.</p>
          <div *ngIf="errorMessage" class="invalid">
            <svg-icon
              src="/assets/icon/icon-info.svg"
              class="icon s-12"
              aria-label="Info"></svg-icon>
            <p class="text">{{ errorMessage }}</p>
          </div>
        </div>
      </div>
      <form
        nz-form
        class="form"
        nzLayout="vertical"
        [formGroup]="loginForm"
        (ngSubmit)="handleFormSubmit()">
        <nz-form-item>
          <nz-form-label nzFor="email">Email</nz-form-label>
          <nz-form-control [nzErrorTip]="emailErrorTpl">
            <nz-input-group nzPrefixIcon="user">
              <input
                name="warningValid"
                type="text"
                nz-input
                id="email"
                formControlName="email"
                [disabled]="showSsoSelection"
                placeholder="Enter your email" />
            </nz-input-group>
          </nz-form-control>
        </nz-form-item>

        <div
          *ngIf="showSsoSelection && ssoOrganizations.length > 1"
          class="sso-selection">
          <nz-form-item>
            <nz-form-label>Sign into Insights to Behavior</nz-form-label>
            <div class="sso-options">
              <div
                *ngFor="let org of ssoOrganizations"
                class="sso-option"
                (click)="selectIdentityProvider(org.idpName)"
                (keydown.enter)="selectIdentityProvider(org.idpName)"
                (keydown.space)="selectIdentityProvider(org.idpName)"
                [class.selected]="selectedIdpName === org.idpName"
                role="button"
                tabindex="0">
                <span class="sso-info">
                  <span class="org-name">Sign in with {{ org.name }}</span>
                </span>
              </div>
            </div>
          </nz-form-item>
        </div>

        <nz-form-item *ngIf="showPasswordField">
          <nz-form-control [nzErrorTip]="passwordErrorTpl">
            <nz-form-label nzFor="password">Password</nz-form-label>
            <nz-input-group [nzSuffix]="suffixTemplate">
              <input
                id="password"
                type="password"
                formControlName="password"
                [type]="passwordVisible ? 'text' : 'password'"
                nz-input
                placeholder="Enter your password" />
            </nz-input-group>
            <ng-template #suffixTemplate>
              <span
                nz-icon
                [nzType]="passwordVisible ? 'eye-invisible' : 'eye'"
                (click)="passwordVisible = !passwordVisible"
                (keydown.enter)="passwordVisible = !passwordVisible"
                (keydown.space)="passwordVisible = !passwordVisible"
                role="button"
                tabindex="0"
                aria-label="Toggle password visibility"
                style="cursor: pointer"></span>
            </ng-template>
          </nz-form-control>
        </nz-form-item>
        <div nz-row class="remember-me" *ngIf="showPasswordField">
          <div class="left">
            <label
              nz-checkbox
              for="rememberMe"
              [nzChecked]="rememberMe"
              (nzCheckedChange)="rememberMe = !rememberMe"
              >Remember me?</label
            >
          </div>
          <div class="right">
            <a class="login-form-forgot" routerLink="/forgot-password"
              >Forgot password</a
            >
          </div>
        </div>
        <button
          *ngIf="
            !showSsoSelection ||
            (showSsoSelection && ssoOrganizations.length === 1)
          "
          type="submit"
          nz-button
          [disabled]="
            showPasswordField
              ? loginForm.invalid || isLoading
              : loginForm.get('email')?.invalid || isLoading
          "
          [nzLoading]="isLoading"
          [nzBlock]="true"
          class="form-button"
          [nzType]="'primary'">
          {{ showPasswordField ? 'Login' : 'Next' }}
        </button>
      </form>
    </div>
  </div>
</div>

<!-- Templates -->

<ng-template #passwordErrorTpl>
  <ng-container *ngIf="loginForm.get('password')?.errors as errors">
    <span *ngIf="errors['required']"> Password is required </span>
    <span *ngIf="!errors['required'] && errors['minlength']">
      Password must be at least 8 characters long
    </span>
    <span
      *ngIf="
        !errors['required'] &&
        !errors['minlength'] &&
        errors['passwordStrength']
      ">
      Password must include uppercase, lowercase, number and special character
    </span>
  </ng-container>
</ng-template>

<ng-template #emailErrorTpl>
  <ng-container *ngIf="loginForm.get('email')?.errors as errors">
    <span *ngIf="loginForm.get('email')?.errors?.['required']">
      Email is required
    </span>
    <span *ngIf="loginForm.get('email')?.errors?.['email']">
      Please enter a valid email address
    </span>
  </ng-container>
</ng-template>
